var baseUrl = "//" + window.location.host + "/api/";
if (window.location.hostname === "localhost") {
  baseUrl = "https://niw-wrank-dev-01.netitwork.net/api/";
}

function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

async function post(path, data) {
  return fetch(baseUrl + path, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(handleErrors)
    .then((response) => response.json());
}

async function post_image(path, data) {
  return fetch(baseUrl + path, {
    method: "POST",
    body: data,
  })
    .then(handleErrors)
    .then((response) => response.json());
}

export function getRooms(values) {
  return async () => {
    return await post("room/read.php", values);
  };
}

export function roomCreate(values) {
  return async () => {
    return await post("room/create.php", values);
  };
}

export function roomUpdate(values) {
  return async () => {
    return await post("room/update.php", values);
  };
}

export function roomPictureUpload(values) {
  return async () => {
    return await post_image("room/savePicture.php", values);
  };
}

export function getReservationsMonth(values) {
  return async () =>{
    return await post("room/read_reservations_month.php", values)
  } 
}

export function reservationCreate(values) {
  return async () =>{
    return await post("room/create_reservation.php", values)
  } 
}

export function reservationUpdate(values) {
  return async () =>{
    return await post("room/update_reservation.php", values)
  } 
}

export function getReservationDetails(values) {
  return async () =>{
    return await post("room/read_reservation_details.php", values)
  } 
}

export function reservationDetailsCreate(values) {
  return async () =>{
    return await post("room/create_reservation_details.php", values)
  } 
}

export function reservationDeleteSingle(values) {
  return async () => {
    return await post("room/delete_single_reservation.php", values)
  }
}

export function reservationRemoveDate(values){
  return async () => {
    return await post("room/remove_date.php", values);
  };
}